// extracted by mini-css-extract-plugin
module.exports = {"layout":"footer_layout__BU_Zv","menu":"footer_menu__xH_UE","credits":"footer_credits__GXzKc"};